export const DOC_LINKS_V2 = {
	home: 'https://help.engati.ai/',
	botOverview: {
		path: 'https://help.engati.ai/conversation-flow-paths',
		faq: 'https://help.engati.ai/faq',
		node: 'https://help.engati.ai/nodes',
	},
	analytics: {
		agentPerformance: 'https://help.engati.ai/agent-performance',
	},
	train: {
		addFaq: 'https://help.engati.ai/faq',
		faq: 'https://help.engati.ai/faq',
		faqBlog: 'https://help.engati.ai/faq/',
		entities: 'https://help.engati.ai/entities',
		tabularInput: 'https://help.engati.ai/tabular-input',
		cognitiveSearch: 'https://help.engati.ai/docusense-search',
		configureSmartResponse: 'https://help.engati.ai/configuring-conversational-intelligence',
		configureCognitiveSearch: 'https://help.engati.ai/docusense-search#cORbr',
		customPrompt: 'https://help.engati.ai/guide-to-custom-prompting',
		platformTutorials: 'https://help.engati.ai/platform-tutorials',
	},
	configure: {
		webDisplay: 'https://help.engati.ai/website-theming',
		liveChat: 'https://help.engati.ai/live-chat-settings',
		teamManage: 'https://help.engati.ai/managing-your-team',
		language: 'https://help.engati.ai/enabling-multiple-languages',
		advancedVoice: 'https://help.engati.ai/enabling-voice-bots',
		advancedDataFormatting: 'https://help.engati.ai/enabling-data-formatting',
		deployment: {
			general: 'https://help.engati.ai/deploying-the-bot',
			fb: 'https://help.engati.ai/facebook',
			whatsapp: 'https://help.engati.ai/whatsapp',
			web: 'https://help.engati.ai/deploying-the-botwebsite/',
			telegram: 'https://help.engati.ai/telegram',
			slack: 'https://help.engati.ai/slack',
			teams: 'https://help.engati.ai/microsoft-teams',
			instagram: {
				link1: 'https://help.engati.ai/instagram-pre-requisites',
				link2: 'https://help.engati.ai/instagram',
			},
			mobile: {
				link1: 'https://help.engati.ai/native-android',
				link2: 'https://help.engati.ai/native-ios',
			},
			email: 'https://help.engati.ai/email',
			waAccelerator: 'https://help.engati.ai/whatsapp-onboarding',
		},
		integrations: {
			home: 'https://help.engati.ai/configuring-integrations',
			ga: 'https://help.engati.ai/configuring-integrationsgoogle-analytics/',
			googleTranslate: 'https://help.engati.ai/configuring-integrationsgoogle-translate/',
			gorgias: 'https://help.engati.ai/configuring-integrationsgorgias/',
			freshdesk: 'https://help.engati.ai/configuring-integrationsfreshdesk/',
			zendesk: 'https://help.engati.ai/configuring-integrationszendesk/',
		},
		shopify: {
			integration: 'https://help.engati.ai/engati-for-shopify-whats-in-it-for-you',
			integrationOnboarding: 'https://help.engati.ai/onboarding-and-deployment',
			setupEngagementTriggers:
				'https://help.engati.ai/engati-for-shopify-whats-in-it-for-youengagement-triggers/',
			GATriggerAnalyticsTemplate:
				'https://analytics.google.com/analytics/web/template?uid=IfJqUe0YQIqzOOuNtHZPyA',
			productDiscovery: 'https://help.engati.ai/engati-for-shopify-whats-in-it-for-youproduct-discovery/',
		},
		woocommerce: {
			integration: 'https://help.engati.ai/engati-for-woocommerce-onboarding-and-deployment',
		},
	},
	users: {
		segments: 'https://help.engati.ai/segments',
		customersegments: 'https://help.engati.ai/customer-segments',
		customAudience: 'https://help.engati.ai/',
		contactList: 'https://help.engati.ai/import-contact-list',
	},
	integrations: {
		cloud: {
			home: 'https://help.engati.ai/configuring-integrations',
			freshdesk: 'https://help.engati.ai/configuring-integrationsfreshdesk/',
			zendesk: 'https://help.engati.ai/configuring-integrationszendesk/',
			gSheets: 'https://help.engati.ai/configuring-integrationsgoogle-sheets/',
			gCalendar: 'https://help.engati.ai/configuring-integrationsgoogle-calendar/',
			gAdmin: 'https://help.engati.ai/configuring-integrationsgoogle-admin-console/',
			salesforce: 'https://help.engati.ai/salesforce',
			shiprocket: 'https://help.engati.ai/shiprocket',
			razorpay: 'https://help.engati.ai/razorpay',
		},
		c2e: 'https://help.engati.ai/configuring-integrationsc2e-bridge/',
		engatiApi: 'https://help.engati.ai/configuring-integrationsengati-apis/',
	},
	broadcast: {
		basic: 'https://help.engati.ai/activating-broadcasts',
		campaigns: 'https://help.engati.ai/campaigns',
		intro: 'https://help.engati.ai/activating-broadcasts',
		segments: 'https://help.engati.ai',
		whatsAppTemplates: 'https://help.engati.ai/send-whatsapp-template-message',
		whatsAppTemplatesTextMedia: 'https://help.engati.ai/message-templates',
		whatsAppTemplatesCarousel: 'https://help.engati.ai/carousel-message-templates',
		whatsAppTemplatesLTO: 'https://help.engati.ai/offer-message-templates',
		whatsAppTemplatesAuthentication: 'https://help.engati.ai/',
		generateCurl: 'https://help.engati.ai/generate-api-for-whatsapp-templates',
		createMessageTemplate: 'https://help.engati.ai/message-templates',
		templateMessageGuidelinesMeta:
			'https://developers.facebook.com/documentation/business-messaging/whatsapp/templates/overview',
		whatsappMarketingTemplate:
			'https://www.engati.ai/blog/frequency-capping?utm_source=platform&utm_medium=broadcast-history&utm_campaign=error-code',
		whatsappCloudErrorCodes:
			'https://developers.facebook.com/documentation/business-messaging/whatsapp/support/error-codes',
	},
	builder: {
		sm: 'https://help.engati.ai/send-message-and-send-message-with-options',
		smo: 'https://help.engati.ai/send-message-and-send-message-with-options',
		sendCarousel: 'https://help.engati.ai/send-carousel',
		sendImage: 'https://help.engati.ai/media-nodes',
		sendVideo: 'https://help.engati.ai/media-nodes',
		sendAudio: 'https://help.engati.ai/media-nodes',
		sendDocument: 'https://help.engati.ai/media-nodes',
		randomizeMessages: 'https://help.engati.ai/randomize-messages',
		customcard: 'https://help.engati.ai/custom-cards',
		feedback: 'https://help.engati.ai/feedback-node',
		rud: 'https://help.engati.ai/request-user-data',
		rudLLM: 'https://help.engati.ai',
		identity: 'https://help.engati.ai/identity-node',
		slider: 'https://help.engati.ai/slider-node',
		formnode: 'https://help.engati.ai/form-node',
		fileUpload: 'https://help.engati.ai/file-upload',
		filterFaq: ' https://help.engati.ai/filter-faq',
		triggerpath: 'https://help.engati.ai/trigger-a-path',
		transferToAgent: 'https://help.engati.ai/transfer-to-agent',
		script: 'https://help.engati.ai/script-node',
		setuserattribute: 'https://help.engati.ai/set-user-attribute',
		sendEmail: 'https://help.engati.ai/send-email',
		pause: 'https://help.engati.ai/pause',
		pythonScript: 'https://help.engati.ai/advanced-script-node',
		decision: 'https://help.engati.ai/decision-node',
		webview: 'https://help.engati.ai/webview-node',
		subscribeToCampaign: 'https://help.engati.ai/campaigns',
		unsubscribeToCampaign: 'https://help.engati.ai/campaigns',
		zendesk: 'https://help.engati.ai/zendesk/',
		salesforce: 'https://help.engati.ai/salesforce',
		freshdesk: 'https://help.engati.ai/freshdesk/',
		googleSheets: 'https://help.engati.ai/google-sheets/',
		googleCalendar: 'https://help.engati.ai/google-calendar/',
		gorgias: 'https://help.engati.ai/gorgias/',
		jsonAPI: 'https://help.engati.ai/json-api',
		templateMessage: 'https://help.engati.ai/template-message',
		zapier: 'https://help.engati.ai/zapier',
		whatsAppFlows: 'https://help.engati.ai/whatsapp-flow',
	},
	whatsAppManager: {
		numbers: {
			commonLink: 'https://help.engati.ai/',
			waOnboardingLink: 'https://help.engati.ai/whatsapp-tsp-onboarding',
			fbmLink: 'https://www.facebook.com/business/help/113163272211510',
			fbmAccountSetupLink: 'https://www.facebook.com/business/help/1710077379203657',
		},
	},
	privacyLink: 'https://www.engati.ai/privacypolicy',
	termOfUse: 'https://www.engati.ai/termsofuse',
	jiraCustomerIssueLink: 'https://engati-ai.atlassian.net/servicedesk/customer/user/login?destination=portals',
	releaseNotes: 'https://help.engati.ai',
	shopifyReleaseNotes: 'https://help.engati.ai/engati-for-shopify-whats-in-it-for-yourelease-notes/',
	configureGoogleAnalytics: 'https://help.engati.ai/google-analytics',
	faq: 'https://help.engati.ai/faq',
	entity: 'https://help.engati.ai/entities',
	shopify: {
		abandonedCheckout: 'https://help.engati.ai/checkout-abandonment',
		orderUpdates: 'https://help.engati.ai/order-updates',
		CodToPrepaid: 'https://help.engati.ai/cash-on-delivery-to-prepaid-conversion',
	},
};
